import { Reveal } from "./Reveal";

export const SectionHeading = ({ overline, title, description, dark = false, align = "left" }) => {
  const alignCls = align === "center" ? "text-center mx-auto" : "text-left";
  return (
    <Reveal className={`max-w-2xl ${alignCls}`}>
      {overline && (
        <p
          data-testid="section-overline"
          className={`text-xs tracking-[0.25em] uppercase font-semibold ${
            dark ? "text-gold" : "text-forest"
          }`}
        >
          {overline}
        </p>
      )}
      <h2
        className={`mt-4 font-display text-3xl sm:text-4xl lg:text-5xl tracking-tight leading-[1.1] ${
          dark ? "text-ivory" : "text-charcoal"
        }`}
      >
        {title}
      </h2>
      {description && (
        <p
          className={`mt-5 text-base md:text-lg leading-relaxed ${
            dark ? "text-ivory/70" : "text-charcoal/70"
          }`}
        >
          {description}
        </p>
      )}
    </Reveal>
  );
};
